module.exports = __webpack_public_path__ + "img/strava-icon.cc7ed9b7.svg";